export default __webpack_public_path__ + "static/media/logo-hh1.869129fd.png";